<template>
  <app-card header="Erman Turkeli Admin" header-center>
    <app-form @submit="onSubmit">
      <app-input
        rules="required|email"
        type="email"
        t-label="email"
        v-model="email"
      />

      <app-input
        rules="required"
        t-label="password"
        type="password"
        v-model="password"
      />
      <b-form-group>
        <!-- <label class="custom-control custom-checkbox">
          <router-link
            :to="{ name: 'forgotPassword' }"
            class="float-right small text-dark mt-1"
            >I forgot password</router-link
          >
        </label> -->
      </b-form-group>

      <div class="form-footer mt-2">
        <b-button type="submit" variant="primary btn-block">{{
          $t('labels.login')
        }}</b-button>
      </div>
    </app-form>
  </app-card>
</template>
<script>
import { ROOT_API } from '@/config/app.config'
export default {
  data() {
    return {
      email: '',
      password: '',
      storeFunctionName: ROOT_API ? 'login' : 'fakeLogin',
    }
  },
  methods: {
    onSubmit() {
      this.login(this.email, this.password)
    },
    login(email, password) {
      this.$store
        .dispatch(this.storeFunctionName, {
          email,
          password,
        })
        .then((res) => {
          if (!res.error) this.$router.push('/')
        })
    },
  },
}
// test commit
</script>
